<div class="col-md-12 col-sm-12 col-xs-12 px-0 mb-2">
    <div class="col-lg-5 col-md-5 col-sm-5 col-xs-12 px-0">
        <div class="filter-options">
            <span>Show</span>
            <select name="catering-entries" aria-controls="catering-entries"
                class="ml-2 grid-header-element number-sort-filter" (change)="updatePagination()"
                [(ngModel)]="selectedPageEntries">
                <option *ngFor="let number of numberOfEntries" [value]="number">
                    {{number}}
                </option>
            </select>
            <span class="ml-2">entries</span>
        </div>
    </div>
    <div class="col-lg-7 col-md-7 col-sm-7 col-xs-12 px-0">
        <div class="row">
            <div class="col-lg-7"></div>
            <!-- ABOVE LINE OF CODE IS NEEDED FOR UI STABILIZATION -->
            <div class="col-lg-5">
                <div id="example1_filter" class="d-flex float-right align-items-center">
                    <span>Search</span> <input type="search"
                        class="ml-2 form-control form-control-sm grid-header-element searchbar-element"
                        aria-controls="example1" [(ngModel)]="searchCateringLogs">
                </div>
            </div>
        </div>
    </div>
</div>
<table id="cateringLog" class="table card-layout table-striped table mt-0">
    <thead>
        <tr>
            <td class="header_td table_heading">
                <div class="header_container text-primary">
                    <div class="header_title cursorPointer col-md-1 leg-number"
                        (click)="cateringLogsSortBy='legSequence'; sortOrder = !sortOrder; legNumber = !legNumber;">
                        Leg Number
                        <i *ngIf="legNumber" class="fa fa-chevron-up margin-left-7"></i>
                        <i *ngIf="!legNumber" class="fa fa-chevron-down margin-left-7"></i>
                    </div>
                    <div class="header_title cursorPointer col-md-1 catering-number"
                        (click)="cateringLogsSortBy='cateringSequence'; sortOrder = !sortOrder; cateringNumber = !cateringNumber;">
                        Catering Number
                        <i *ngIf="cateringNumber" class="fa fa-chevron-up margin-left-7"></i>
                        <i *ngIf="!cateringNumber" class="fa fa-chevron-down margin-left-7"></i>
                    </div>
                    <div class="header_title cursorPointer col-md-1 origin"
                        (click)="cateringLogsSortBy='addressName'; sortOrder = !sortOrder; legOrigin = !legOrigin;">
                        Origin
                        <i *ngIf="legOrigin" class="fa fa-chevron-up margin-left-7"></i>
                        <i *ngIf="!legOrigin" class="fa fa-chevron-down margin-left-7"></i>
                    </div>
                    <div class="header_title cursorPointer col-md-1 destination"
                        (click)="cateringLogsSortBy='addressName'; sortOrder = !sortOrder; legDestination = !legDestination;">
                        Destination
                        <i *ngIf="legDestination" class="fa fa-chevron-up margin-left-7"></i>
                        <i *ngIf="!legDestination" class="fa fa-chevron-down margin-left-7"></i>
                    </div>
                    <div class="header_title cursorPointer col-md-1 previous-status"
                        (click)="cateringLogsSortBy='previousStatus'; sortOrder = !sortOrder; previousStatus = !previousStatus;">
                        Previous Status
                        <i *ngIf="previousStatus" class="fa fa-chevron-up margin-left-7"></i>
                        <i *ngIf="!previousStatus" class="fa fa-chevron-down margin-left-7"></i>
                    </div>
                    <div class="header_title cursorPointer col-md-1 updated-status"
                        (click)="cateringLogsSortBy='currentStatus'; sortOrder = !sortOrder; updatedStatus = !updatedStatus;">
                        Updated Status
                        <i *ngIf="updatedStatus" class="fa fa-chevron-up margin-left-7"></i>
                        <i *ngIf="!updatedStatus" class="fa fa-chevron-down margin-left-7"></i>
                    </div>
                    <div class="header_title cursorPointer col-md-1 created-on"
                        (click)="cateringLogsSortBy='createdOn'; sortOrder = !sortOrder; createdOn = !createdOn;">
                        Created On
                        <i *ngIf="createdOn" class="fa fa-chevron-up margin-left-7"></i>
                        <i *ngIf="!createdOn" class="fa fa-chevron-down margin-left-7"></i>
                    </div>
                    <div class="header_title cursorPointer col-md-1 created-by"
                        (click)="cateringLogsSortBy='createdBy'; sortOrder = !sortOrder; createdBy = !createdBy;">
                        Created By
                        <i *ngIf="createdBy" class="fa fa-chevron-up margin-left-7"></i>
                        <i *ngIf="!createdBy" class="fa fa-chevron-down margin-left-7"></i>
                    </div>
                    <div class="header_title cursorPointer col-md-1 updated-on"
                        (click)="cateringLogsSortBy='updatedOn'; sortOrder = !sortOrder; updatedOn = !updatedOn;">
                        Updated On
                        <i *ngIf="updatedOn" class="fa fa-chevron-up margin-left-7"></i>
                        <i *ngIf="!updatedOn" class="fa fa-chevron-down margin-left-7"></i>
                    </div>
                    <div class="header_title cursorPointer col-md-1 updated-by"
                        (click)="cateringLogsSortBy='updatedBy'; sortOrder = !sortOrder; updatedBy = !updatedBy;">
                        Updated By
                        <i *ngIf="updatedBy" class="fa fa-chevron-up margin-left-7"></i>
                        <i *ngIf="!updatedBy" class="fa fa-chevron-down margin-left-7"></i>
                    </div>
                    <div class="header_title cursorPointer col-md-1 operation-type"
                        (click)="cateringLogsSortBy='operationType'; sortOrder = !sortOrder; operationType = !operationType;">
                        Operation Type
                        <i *ngIf="operationType" class="fa fa-chevron-up margin-left-7"></i>
                        <i *ngIf="!operationType" class="fa fa-chevron-down margin-left-7"></i>
                    </div>
                    <div class="header_title cursorPointer col-md-1 previous-values"
                        (click)="cateringLogsSortBy='previousValueDescription'; sortOrder = !sortOrder; previousValues = !previousValues;">
                        Previous Values
                        <i *ngIf="previousValues" class="fa fa-chevron-up margin-left-7"></i>
                        <i *ngIf="!previousValues" class="fa fa-chevron-down margin-left-7"></i>
                    </div>
                    <div class="header_title cursorPointer col-md-1 current-values"
                        (click)="cateringLogsSortBy='currentValueDescription'; sortOrder = !sortOrder; currentValues = !currentValues;">
                        Current Values
                        <i *ngIf="currentValues" class="fa fa-chevron-up margin-left-7"></i>
                        <i *ngIf="!currentValues" class="fa fa-chevron-down margin-left-7"></i>
                    </div>
                </div>
            </td>
        </tr>
    </thead>
    <tbody>
        <tr *ngFor="let log of cateringLogs
            | orderBy: cateringLogsSortBy:sortOrder
            | filter: searchCateringLogs
            | paginate: { id:'cateringLogsPagination', itemsPerPage: selectedPageEntries, currentPage: currentPage };
            let i = index">
            <td>
                <div class="row_container">
                    <div class="title_container col-md-1 leg-number">
                        <div class="row_title">Leg Number</div>
                        <div class="row_detail">
                            {{ log.legSequence }}
                        </div>
                    </div>
                    <div class="title_container col-md-1 catering-number">
                        <div class="row_title">Catering Number</div>
                        <div class="row_detail">
                            {{ log.cateringSequence }}
                        </div>
                    </div>
                    <div class="title_container col-md-1 origin">
                        <div class="row_title">Origin</div>
                        <div class="row_detail">
                            <b>{{ log?.legOrigin?.addressName }}</b>
                            <br>
                            {{ log?.legOrigin?.streetAddress }}
                            {{ log?.legOrigin?.city }},
                            {{ log?.legOrigin?.zipCode }}
                        </div>
                    </div>
                    <div class="title_container col-md-1 destination">
                        <div class="row_title">Destination</div>
                        <div class="row_detail">
                            <b>{{ log?.legDestination?.addressName }}</b>
                            <br>
                            {{ log?.legDestination?.streetAddress }}
                            {{ log?.legDestination?.city }},
                            {{ log?.legDestination?.zipCode }}
                        </div>
                    </div>
                    <div class="title_container col-md-1 previous-status">
                        <div class="row_title">Previous Status</div>
                        <div class="row_detail">
                            <div *ngIf="log.previousStatus; else elseBlock">
                                {{ log.previousStatus }}
                            </div>
                            <ng-template #elseBlock>
                                NA
                            </ng-template>
                        </div>
                    </div>
                    <div class="title_container col-md-1 updated-status">
                        <div class="row_title">Updated Status</div>
                        <div class="row_detail">
                            {{ log.currentStatus }}
                        </div>
                    </div>
                    <div class="title_container col-md-1 created-on">
                        <div class="row_title">Created On</div>
                        <div class="row_detail">
                            {{ log.createdOn | localDate }}
                        </div>
                    </div>
                    <div class="title_container col-md-1 created-by">
                        <div class="row_title">Created By</div>
                        <div class="row_detail">
                            {{ log.createdBy }}
                        </div>
                    </div>
                    <div class="title_container col-md-1 updated-on">
                        <div class="row_title">Updated On</div>
                        <div class="row_detail">
                            {{ log.updatedOn | localDate }}
                        </div>
                    </div>
                    <div class="title_container col-md-1 updated-by">
                        <div class="row_title">Updated By</div>
                        <div class="row_detail">
                            {{ log.updatedBy }}
                        </div>
                    </div>
                    <div class="title_container col-md-1 operation-type">
                        <div class="row_title">Operation Type</div>
                        <div class="row_detail">
                            {{ log.operationType }}
                        </div>
                    </div>
                    <div class="title_container col-md-1 previous-values">
                        <div class="row_title">Previous Values</div>
                        <div class="row_detail">
                            <ng-container *ngIf="log.previousValueDescription; else elseBlock">
                                <ng-container *ngFor="let previousDetail of log.previousValueDescription">
                                    <div>{{ previousDetail }}</div>
                                </ng-container>
                            </ng-container>
                            <ng-template #elseBlock>
                                NA
                            </ng-template>
                        </div>
                    </div>
                    <div class="title_container col-md-1 current-values">
                        <div class="row_title">Current Values</div>
                        <div class="row_detail">
                            <ng-container *ngFor="let currentDetail of log.currentValueDescription">
                                <div>{{ currentDetail }}</div>
                            </ng-container>
                        </div>
                    </div>
                </div>
            </td>
        </tr>
    </tbody>
</table>
<div *ngIf="cateringLogs?.length==0" class="text-color"><b>No Record Available</b></div>
<div class="col-md-12 p-0" *ngIf="cateringLogs?.length != 0">
    <div class="col-md-6 p-0" id="left">
        {{pagination}}
    </div>

    <div class="col-md-6 pagination text-end" id="catering">
        <pagination-controls previousLabel="" nextLabel="" [responsive]="true" (pageChange)="currentPageChange($event)"
            id="cateringLogsPagination">
        </pagination-controls>
    </div>
</div>